export const tokens = {
    colors: {
        primary: '#030712',
        secondary: '#2B6CB0',
        text: '#2D3748',
        background: '#F7FAFC',
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 16,
        lg: 24,
    },
    fonts: {
        body: 'Helvetica',
        bold: 'Helvetica-Bold',
    },
    fontSizes: {
        xs: 8,
        sm: 9,
        md: 11,
        lg: 14,
        xl: 20,
        xxl: 30,
    },

};
